module.exports = __webpack_public_path__ + "sTdaA6j0Psb920Vjv-mrzH-_kf6ByYO6CLYdB4HQE-Y.80ea3224d5d608d68089.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/font-google/sTdaA6j0Psb920Vjv-mrzH-_kf6ByYO6CLYdB4HQE-Y.woff2
// module id = ../../../../../src/assets/fonts/font-google/sTdaA6j0Psb920Vjv-mrzH-_kf6ByYO6CLYdB4HQE-Y.woff2
// module chunks = 40